export default "__VITE_ASSET__012d925b__"